import TextDivider from './TextDivider';
import { TextDividerProps, TextDividerValueProps } from './types';

export type { TextDividerProps, TextDividerValueProps };
export default TextDivider;
